import { getCookie } from './cookie-reader';

function decodeBase64(string: string) {
  const b64 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
  const b64re = /^(?:[A-Za-z\d+\/]{4})*?(?:[A-Za-z\d+\/]{2}(?:==)?|[A-Za-z\d+\/]{3}=?)?$/;
  string = String(string).replace(/[\t\n\f\r ]+/g, '');

  string += '=='.slice(2 - (string.length & 3));
  var bitmap,
    result = '',
    r1,
    r2,
    i = 0;
  for (; i < string.length; ) {
    bitmap =
      (b64.indexOf(string.charAt(i++)) << 18) | (b64.indexOf(string.charAt(i++)) << 12) | ((r1 = b64.indexOf(string.charAt(i++))) << 6) | (r2 = b64.indexOf(string.charAt(i++)));

    result +=
      r1 === 64
        ? String.fromCharCode((bitmap >> 16) & 255)
        : r2 === 64
          ? String.fromCharCode((bitmap >> 16) & 255, (bitmap >> 8) & 255)
          : String.fromCharCode((bitmap >> 16) & 255, (bitmap >> 8) & 255, bitmap & 255);
  }
  return result;
}

export function getAccessToken() {
  return localStorage.getItem('accessToken') || getCookie('EE3B69BC-D275-4D89-ACCD-D91136DAD45C') || '';
}

export function getAccessTokenPayloadInfo(info: string): string | null {
  try {
    const token = getAccessToken();
    const payload = token.split('.')[1];

    if (!payload) {
      return null;
    }

    const parsed = JSON.parse(decodeBase64(payload)) as Record<string, string>;
    return parsed[info] ?? null;
  } catch {
    return null;
  }
}
